import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FAL_EXCLAMATION_CIRCLE, FAR_ANGLE_DOWN, FAR_ANGLE_UP, FAR_DOLLAR_SIGN } from '../../../../const/iconProps';
import { paymentTypes } from '../../../../const/paymentOptions';
import MainContext from '../../../../Context';
import { isAutopayEnrollmentEligible } from '../../../../helpers';
import useApiMachine from '../../../../hooks/machines/useApiMachine';
import { useDigitalCollections } from '../../../../hooks/useDigitalCollections';
import { t } from '../../../../strings/i18n';
import SelectWithFocus from '../../../atoms/SelectWithFocus';
import { SelectWrapper } from '../subcomponents';
import { getPaymentOption, getPaymentTypeOptions } from './helpers';
const PaymentTypeSelect = ({ value, error }) => {
    const { sendToMainMachine, featureFlags } = useContext(MainContext);
    const [apiMachine] = useApiMachine();
    const { accountSummaryQueryResult, autopayStatusQueryResult, paymentEnterpriseEligibilityQueryResult } = apiMachine.context;
    const { data: accountSummary } = accountSummaryQueryResult;
    const { data: autopayStatus } = autopayStatusQueryResult;
    const { data: paymentEnterpriseEligibility } = paymentEnterpriseEligibilityQueryResult;
    const productType = accountSummary.product.type;
    const isAutopayEnrolled = autopayStatus.enrollment;
    const isAutopayEnrollEligible = isAutopayEnrollmentEligible(paymentEnterpriseEligibility);
    const { isSettlement } = useDigitalCollections();
    const id = 'paymentType';
    const paymentTypeOptions = getPaymentTypeOptions({
        isAutopayEnrolled,
        isAutopayEnrollEligible,
        isSettlement,
        productType,
        featureFlags
    });
    const defaultOption = getPaymentOption(paymentTypeOptions, value);
    const isOnlyOptionAvailable = paymentTypeOptions.length === 1;
    const handlePaymentTypeChange = (paymentType) => {
        switch (paymentType) {
            case paymentTypes.ONCE:
                sendToMainMachine({
                    type: 'SET_ONE_TIME_PAYMENT_FLOW'
                });
                break;
            case paymentTypes.AUTOPAY:
                sendToMainMachine({
                    type: 'SET_AUTOPAY_FLOW',
                    isPaymentTypeVisible: true
                });
                break;
            case paymentTypes.PAYOFF:
                sendToMainMachine({
                    type: 'SET_PAYOFF_PAYMENT_FLOW'
                });
                break;
            default:
                break;
        }
    };
    return (_jsx(SelectWrapper, Object.assign({ horizontal: "medium" }, { children: _jsx(SelectWithFocus, { autoAdjust: true, dataCy: "payment-type-field", defaultOption: defaultOption, error: error, errorIcon: _jsx(FontAwesomeIcon, { icon: FAL_EXCLAMATION_CIRCLE, size: "1x" }), id: id, isDisabled: isOnlyOptionAvailable || isSettlement, leftIcon: _jsx(FontAwesomeIcon, { icon: FAR_DOLLAR_SIGN }), name: id, options: paymentTypeOptions, placeholder: t('makePayment.paymentType'), required: true, rightIconClosed: _jsx(FontAwesomeIcon, { icon: FAR_ANGLE_DOWN, size: "lg" }), rightIconOpen: _jsx(FontAwesomeIcon, { icon: FAR_ANGLE_UP, size: "lg" }), tabIndex: isOnlyOptionAvailable ? -1 : 0, onChange: ({ value: option }) => handlePaymentTypeChange(option) }) })));
};
export default PaymentTypeSelect;
